// ============================================================================
//  METABASE DEFAULTS — baked into the .dmg.
// ----------------------------------------------------------------------------
//  These credentials auto-register on first launch so the value indicators
//  and the Funnel charts go LIVE without the user touching Settings. If you
//  rotate the Metabase API key, change it here and rebuild — or override per
//  device in Settings → Data sources.
//
//  Tradeoff: anyone with an extracted bundle could read the key. Mitigated by
//  the passphrase gate + email allowlist. Use a read-only Metabase API key.
// ============================================================================

import type { DataSourceSpec } from "../lib/types";

export const DEFAULT_METABASE_SPEC: DataSourceSpec = {
  id: "metabase-bvndle",
  label: "Bvndle Metabase",
  kind: {
    kind: "metabase",
    url: "https://bvndle-loyalty-limited-60.metabaseapp.com",
    default_database_id: 100,
  },
  auth: {
    kind: "api_key",
    key: "mb_eKMb2FQFKeN6dymixs6gqlcTRgl/n4jxIEfFB0RkAIc=",
  },
};
